import { useRef as s, useEffect as l } from "react";
const c = r => {
  const e = s(null);
  return l(() => {
    if (!r || !(e != null && e.current)) return;
    const t = e.current.querySelector("textarea");
    if (!t) return;
    const n = () => {
      var i;
      const o = ((i = window.getComputedStyle(t)) == null ? void 0 : i.lineHeight) || "0",
        u = 5 * parseFloat(o);
      t.style.height = "0px", t.style.height = "".concat(Math.min(t.scrollHeight, u), "px");
    };
    return window.addEventListener("input", n), () => {
      window.removeEventListener("input", n);
    };
  }, [r, e]), e;
};
export { c as useAutosize };